/** メンテナンス開始日時の昇順で並べ替える */
export const sortOtacByStartAt = <T extends { maintenanceStartAt: string }>(schedules: T[]): T[] =>
  [...schedules].sort((a, b) => new Date(a.maintenanceStartAt).getTime() - new Date(b.maintenanceStartAt).getTime())
